/** A labeled stop on an input slider track */
export interface InputSliderItem {
  value: number;
  label: string;
}

/** Display styles for input slider track markers */
export enum InputSliderMarkerStyle {
  HIDDEN = 'Hidden',
  DISPLAY_INDEX = 'DISPLAY_INDEX',
  DISPLAY_VALUE = 'DISPLAY_VALUE',
}

/** Display styles for the input slider's selected value label */
export enum InputSliderSelectionStyle {
  HIDDEN = 'HIDDEN',
  LABEL_ONLY = 'LABEL_ONLY',
  INDEX_WITH_LABEL = 'INDEX_WITH_LABEL',
  VALUE_WITH_LABEL = 'VALUE_WITH_LABEL',
}